import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export function ComparableSelectionHeader() {
  const { t } = useTranslation();
  return (
    <h1 className="text-xs self-center font-semibold text-text-base-tertiary uppercase">{t("comparables.header")}</h1>
  );
}
